export const DOTS = "...";
